import { forwardRef } from "react";
import MuiIconButton, { type IconButtonProps } from "@mui/material/IconButton";
import { useForkRef } from "@mui/material/utils";
import { useGoogleAttributes } from "@/lib/translation/useGoogleAttributes";

const GoogleIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function GoogleIconButton(props, forwardedRef) {
    const { ref } = useGoogleAttributes<HTMLButtonElement>(
      props.translate === "no"
        ? {}
        : {
            "aria-label": props["aria-label"],
            title: props.title,
          },
    );
    const buttonRef = useForkRef(forwardedRef, ref);
    return <MuiIconButton {...props} ref={buttonRef} />;
  },
);

export default GoogleIconButton as typeof MuiIconButton;
